<template>
  <div></div>
</template>

<script>
export default {
  data () {
    return {}
  },
  components: {},
  methods: {},
  mounted () {}
}
</script>

<style lang="less" scoped>
</style>
